import styled, { css } from 'styled-components'

export const SliderContainer = styled.div(
    ({ theme }) => css`
        position: ${theme.style.position.relative};
        max-width: fit-content;
        margin-top: ${theme.spacing.xSmall};
    `,
)

export const StyledCarouselProvider = styled.div<{ margin?: string; center?: boolean }>`
    width: 100%;
    margin: ${({ margin }) => margin ?? '0'};
    li {
        list-style: none;
    }
`

export const StyledSlider = styled.div`
    padding: 0;
    overflow: hidden;
`
